import { ADD_PROMO_CODE_ERROR, ADD_PROMO_CODE_REQUEST, ADD_PROMO_CODE_SUCCESS, ADD_TO_CART_ERROR, ADD_TO_CART_REQUEST, ADD_TO_CART_SUCCESS, ASSOCIATE_CART_WITH_USER_ERROR, ASSOCIATE_CART_WITH_USER_REQUEST, ASSOCIATE_CART_WITH_USER_SUCCESS, AUTH_LOGOUT_REQUEST, FORGET_CART, INITIALIZE_STATE_FROM_STORAGE, LOAD_CART_ERROR, LOAD_CART_REQUEST, LOAD_CART_SUCCESS, MODIFY_CART_ERROR, MODIFY_CART_GIFT_CARDS_REQUEST, MODIFY_CART_GIFT_CARDS_SUCCESS, MODIFY_CART_GIFT_CARDS_ERROR, MODIFY_CART_REQUEST, MODIFY_CART_SUCCESS, REMOVE_FROM_CART_ERROR, REMOVE_FROM_CART_REQUEST, REMOVE_FROM_CART_SUCCESS, REMOVE_PROMO_CODE_ERROR, REMOVE_PROMO_CODE_REQUEST, REMOVE_PROMO_CODE_SUCCESS, ADD_SUBSCRIPTION_ERROR, ADD_SUBSCRIPTION_REQUEST, ADD_SUBSCRIPTION_SUCCESS, UPDATE_ORDER_ADDRESSES_REQUEST, UPDATE_ORDER_ADDRESSES_SUCCESS, UPDATE_ORDER_ADDRESSES_ERROR, UPDATE_ORDER_DELIVERY_REQUEST, UPDATE_ORDER_DELIVERY_SUCCESS, UPDATE_ORDER_DELIVERY_ERROR, UPDATE_ORDER_PAYMENT_REQUEST, UPDATE_ORDER_PAYMENT_SUCCESS, UPDATE_ORDER_PAYMENT_ERROR, MODIFY_CART_LINE_ITEM_ERROR, MODIFY_CART_LINE_ITEM_REQUEST, MODIFY_CART_LINE_ITEM_SUCCESS, MODIFY_CHECKOUT_ERROR, MODIFY_CHECKOUT_REQUEST, MODIFY_CHECKOUT_SUCCESS, COMPLETE_CHECKOUT_STEP_ERROR, COMPLETE_CHECKOUT_STEP_REQUEST, COMPLETE_CHECKOUT_STEP_SUCCESS, PREPARE_CHECKOUT_REQUEST, PREPARE_CHECKOUT_SUCCESS, PREPARE_CHECKOUT_ERROR, } from '../actions/types';
import initialState from '../store/initial-state';
// eslint-disable-next-line default-param-last
const cart = (state = initialState.cart, action) => {
    switch (action.type) {
        case MODIFY_CART_REQUEST:
        case MODIFY_CHECKOUT_REQUEST:
        case COMPLETE_CHECKOUT_STEP_REQUEST:
        case PREPARE_CHECKOUT_REQUEST:
        case ADD_TO_CART_REQUEST:
        case LOAD_CART_REQUEST:
        case ADD_SUBSCRIPTION_REQUEST:
        case ASSOCIATE_CART_WITH_USER_REQUEST:
        case UPDATE_ORDER_ADDRESSES_REQUEST:
        case UPDATE_ORDER_DELIVERY_REQUEST:
        case UPDATE_ORDER_PAYMENT_REQUEST:
            return {
                ...state,
                isFetching: true,
                isLoaded: false,
                error: null,
            };
        case REMOVE_FROM_CART_REQUEST:
        case MODIFY_CART_LINE_ITEM_REQUEST:
        case MODIFY_CART_GIFT_CARDS_REQUEST:
            return {
                ...state,
                isFetching: false,
                isLoaded: false,
                error: null,
            };
        case LOAD_CART_SUCCESS:
        case MODIFY_CART_SUCCESS:
        case MODIFY_CHECKOUT_SUCCESS:
        case COMPLETE_CHECKOUT_STEP_SUCCESS:
        case PREPARE_CHECKOUT_SUCCESS:
        case ADD_TO_CART_SUCCESS:
        case MODIFY_CART_LINE_ITEM_SUCCESS:
        case MODIFY_CART_GIFT_CARDS_SUCCESS:
        case REMOVE_FROM_CART_SUCCESS:
        case ADD_SUBSCRIPTION_SUCCESS:
        case ASSOCIATE_CART_WITH_USER_SUCCESS:
        case UPDATE_ORDER_ADDRESSES_SUCCESS:
        case UPDATE_ORDER_DELIVERY_SUCCESS:
        case UPDATE_ORDER_PAYMENT_SUCCESS:
            return {
                ...state,
                isFetching: false,
                isLoaded: true,
                error: null,
                data: action.data,
            };
        case FORGET_CART:
            return {
                ...state,
                isFetching: false,
                isLoaded: true,
                error: null,
                data: {},
            };
        case LOAD_CART_ERROR:
        case ADD_TO_CART_ERROR:
        case MODIFY_CART_ERROR:
        case MODIFY_CHECKOUT_ERROR:
        case COMPLETE_CHECKOUT_STEP_ERROR:
        case PREPARE_CHECKOUT_ERROR:
        case ADD_SUBSCRIPTION_ERROR:
        case ASSOCIATE_CART_WITH_USER_ERROR:
        case UPDATE_ORDER_ADDRESSES_ERROR:
        case UPDATE_ORDER_DELIVERY_ERROR:
        case UPDATE_ORDER_PAYMENT_ERROR:
            return {
                ...state,
                error: action.payload,
                isFetching: false,
            };
        case REMOVE_FROM_CART_ERROR:
        case MODIFY_CART_LINE_ITEM_ERROR:
        case MODIFY_CART_GIFT_CARDS_ERROR:
            return {
                ...state,
                error: action.payload,
            };
        case ADD_PROMO_CODE_REQUEST:
            return {
                ...state,
                promoCode: {
                    isFetching: true,
                },
            };
        case ADD_PROMO_CODE_SUCCESS:
            return {
                ...state,
                data: action.data,
                promoCode: {
                    isFetching: false,
                },
            };
        case ADD_PROMO_CODE_ERROR:
            return {
                ...state,
                promoCode: {
                    isFetching: false,
                },
            };
        case REMOVE_PROMO_CODE_REQUEST:
            return {
                ...state,
                promoCode: {
                    isFetching: true,
                },
            };
        case REMOVE_PROMO_CODE_SUCCESS:
            return {
                ...state,
                data: action.data,
                promoCode: {
                    isFetching: false,
                },
            };
        case REMOVE_PROMO_CODE_ERROR:
            return {
                ...state,
                promoCode: {
                    isFetching: false,
                },
            };
        case INITIALIZE_STATE_FROM_STORAGE: {
            const { number, token } = action.payload.cart.data;
            const lineItems = token ? null : [];
            return {
                ...state,
                data: {
                    ...state.data,
                    lineItems,
                    number,
                    token,
                },
            };
        }
        case AUTH_LOGOUT_REQUEST:
            return {
                ...state,
                data: {
                    ...state.data,
                    number: null,
                    token: null,
                },
            };
        default:
            return state;
    }
};
export default cart;
